var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEmptyStateTrackers = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 400,
    height: 260,
    viewBox: "0 0 400 260",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M71.0509 226.437C71.3619 225.12 70.5458 223.799 69.2282 223.488C67.9105 223.177 66.5902 223.993 66.2792 225.311C65.9682 226.629 66.7842 227.949 68.1019 228.26C69.4196 228.571 70.7399 227.755 71.0509 226.437Z",
    fill: "#071A24"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M312.854 70.2081C313.165 68.8905 312.349 67.5701 311.031 67.2591C309.713 66.9481 308.393 67.7642 308.082 69.0819C307.771 70.3996 308.587 71.7199 309.905 72.0309C311.223 72.3419 312.543 71.5258 312.854 70.2081Z",
    fill: "#071A24"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M351.725 39.3595C346.494 40.6636 345.243 42.2785 344.356 49.6768C344.303 50.1077 343.697 50.1077 343.644 49.6768C342.759 42.2762 341.506 40.6636 336.275 39.3595C335.908 39.2688 335.908 38.7312 336.275 38.6405C341.506 37.3364 342.757 35.7215 343.644 28.3232C343.697 27.8923 344.303 27.8923 344.356 28.3232C345.241 35.7238 346.494 37.3364 351.725 38.6405C352.092 38.7312 352.092 39.2688 351.725 39.3595Z",
    stroke: "#071A24",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M230.855 178.835C238.356 185.171 247.599 188.095 256.7 187.756C265.068 187.449 273.318 184.377 279.96 178.663C281.477 177.367 282.909 175.927 284.238 174.352C285.739 172.573 287.052 170.7 288.168 168.749C297.117 153.178 293.952 132.97 279.751 120.973C263.775 107.468 239.873 109.476 226.372 125.456C223.804 128.499 221.795 131.828 220.339 135.317C214.143 150.156 217.918 167.902 230.855 178.835V178.835Z",
    stroke: "#071A24",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M237.12 171.423C242.797 176.221 249.82 178.384 256.699 178.041C264.221 177.669 271.579 174.294 276.822 168.086C286.867 156.204 285.375 138.429 273.489 128.384C261.603 118.343 243.828 119.836 233.783 131.717C232.809 132.866 231.946 134.069 231.194 135.316C224.126 146.969 226.384 162.351 237.12 171.423Z",
    stroke: "#071A24",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M279.96 178.663L292.565 189.314C293.694 190.267 295.391 190.124 296.344 188.995L301.191 183.261C302.144 182.132 302.001 180.434 300.872 179.481L288.168 168.745L279.96 178.663Z",
    fill: "#071A24"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M343.883 225.662L345.273 224.018C345.899 223.277 345.805 222.157 345.065 221.527L295.796 179.894C295.056 179.269 293.935 179.363 293.305 180.103L291.915 181.747C291.289 182.488 291.383 183.608 292.123 184.238L341.392 225.871C342.132 226.496 343.253 226.402 343.883 225.662V225.662Z",
    stroke: "#071A24",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M364.336 186.365C364.336 186.365 307.08 164.176 293.186 204.148C281.186 238.676 311.82 237.281 310.748 222.165C309.938 210.733 293.186 197.219 279.959 200.684C264.465 204.741 265.014 218.7 272.404 218.929C281.406 219.212 279.635 204.156 273.095 189.947",
    stroke: "#071A24",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M275.942 89.2712L269.73 106.997",
    stroke: "#071A24",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M288.303 95.1606L278.663 111.279",
    stroke: "#071A24",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M300.367 104.134L286.915 117.243",
    stroke: "#071A24",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M161.896 216.278C161.896 210.441 166.096 206.245 171.928 206.245C166.092 206.245 161.896 202.045 161.896 196.212C161.896 202.049 157.695 206.245 151.863 206.245C157.699 206.245 161.896 210.445 161.896 216.278Z",
    fill: "#071A24",
    stroke: "#071A24",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M276.865 56.1483C277.5 53.4618 275.835 50.7695 273.149 50.1349C270.461 49.5004 267.768 51.1644 267.135 53.8521C266.5 56.5386 268.165 59.231 270.851 59.8655C273.539 60.4989 276.232 58.8348 276.865 56.1483Z",
    fill: "#071A24"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M236.871 38.4089H56.1088C54.8429 38.4089 53.8167 39.4379 53.8167 40.7071V157.968C53.8167 159.237 54.8429 160.266 56.1088 160.266H236.871C238.137 160.266 239.163 159.237 239.163 157.968V40.7071C239.163 39.4379 238.137 38.4089 236.871 38.4089Z",
    stroke: "#071A24",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M53.8167 66.2837H239.163",
    stroke: "#071A24",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M73.4491 56.2577C75.647 54.054 75.647 50.4811 73.4491 48.2774C71.2512 46.0737 67.6876 46.0737 65.4897 48.2774C63.2918 50.4811 63.2918 54.054 65.4897 56.2577C67.6876 58.4615 71.2512 58.4615 73.4491 56.2577Z",
    fill: "#4767FF",
    stroke: "#4767FF",
    strokeWidth: 2.5,
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M89.0891 57.4788C91.9608 56.2861 93.3245 52.9852 92.135 50.1059C90.9455 47.2266 87.6532 45.8593 84.7815 47.052C81.9098 48.2446 80.5461 51.5455 81.7356 54.4248C82.9251 57.3041 86.2174 58.6714 89.0891 57.4788Z",
    fill: "#4767FF",
    stroke: "#4767FF",
    strokeWidth: 2.5,
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M104.943 57.7493C108.052 57.7493 110.571 55.2228 110.571 52.1063C110.571 48.9898 108.052 46.4634 104.943 46.4634C101.835 46.4634 99.3152 48.9898 99.3152 52.1063C99.3152 55.2228 101.835 57.7493 104.943 57.7493Z",
    fill: "#4767FF",
    stroke: "#4767FF",
    strokeWidth: 2.5,
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M217.592 46.4688L228.832 57.7439",
    stroke: "#071A24",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M228.832 46.4688L217.592 57.7439",
    stroke: "#071A24",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M68.6025 81.4106L80.5529 91.159L68.6025 100.907",
    stroke: "#071A24",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M87.2947 81.4106V100.907",
    stroke: "#071A24",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M95.7478 81.4106V100.907",
    stroke: "#071A24",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M174.144 105.229L162.193 114.977L174.144 124.725",
    stroke: "#4767FF",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M126.471 105.229L138.422 114.977L126.471 124.725",
    stroke: "#4767FF",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M104.943 91.1592H221.945",
    stroke: "#071A24",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M68.6025 138.79H205.636",
    stroke: "#071A24",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M68.6025 114.977H121.677",
    stroke: "#4767FF",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M177.383 114.977H221.945",
    stroke: "#4767FF",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M143.807 128.977V100.977H156.807V128.977H143.807Z",
    fill: "#4767FF",
    stroke: "#4767FF",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEmptyStateTrackers);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/EmptyStateTrackers.ba3517de86afa9938d610709c6c06741.svg";